/**
 * 상대 시간 표시 — BUILDER-UX-POLICY §4 「상대 시간 표시 규칙 (공통)」 표 그대로.
 *
 * | 경과 | 표시 |
 * |---|---|
 * | 1분 미만 | 방금 |
 * | 1시간 미만 | N분 전 |
 * | 오늘 | 오늘 HH:MM |
 * | 어제 | 어제 |
 * | 2~6일 | N일 전 |
 * | 7일+ | M월 D일 |
 *
 * 🔑 **미래 시각 clamp**: 기기 시계가 서버보다 뒤면 `diffMs < 0` 이 된다.
 *    그때 "-3분 전" 같은 걸 보여주지 않고 «방금» 으로 고정한다(정책 각주).
 */

export interface RelativeTimeOptions {
  /** 기준 시각. 테스트에서 고정하려고 받는다(기본 = 지금). */
  now?: Date;
  /** 세션 시작 시간용 기본 모드는 「방금 시작」, 활동 피드용 compact 모드는 「방금」. */
  mode?: "default" | "compact";
}

function startOfDay(value: Date): number {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
}

export function formatRelativeTime(iso: string, options: RelativeTimeOptions = {}): string {
  const now = options.now ?? new Date();
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return "";

  const compact = options.mode === "compact";
  const justNow = compact ? "방금" : "방금 시작";
  const diffMs = now.getTime() - at.getTime();
  if (diffMs < 0) return justNow;
  if (diffMs < 60_000) return justNow;
  if (diffMs < 3_600_000) return `${Math.floor(diffMs / 60_000)}분 전`;

  const dayDiff = Math.round((startOfDay(now) - startOfDay(at)) / 86_400_000);
  if (dayDiff <= 0) {
    const time = `${String(at.getHours()).padStart(2, "0")}:${String(at.getMinutes()).padStart(2, "0")}`;
    return compact ? `오늘 ${time}` : `오늘 ${time} 시작`;
  }
  if (dayDiff === 1) return "어제";
  if (dayDiff < 7) return `${dayDiff}일 전`;
  return `${at.getMonth() + 1}월 ${at.getDate()}일`;
}
